<div class="inner-icon right-icon" [class.is-valid]="valid" [class.is-invalid]="invalid">
  <i class="far fa-calendar fa-sm" (click)="datePicker.toggle()"></i>
  <input
    class="form-control {{ props.cssClass }}"
    ngbDatepicker
    #datePicker="ngbDatepicker"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [startDate]="startDate"
    [id]="key"
    [placeholder]="props.placeholder"
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [class.is-valid]="valid"
    [class.is-invalid]="invalid"
    (click)="datePicker.toggle()"
    (dateSelect)="change()"
    (navigate)="navigate($event)"
  />
</div>
